/*
 * @Author: wulan
 * @Date: 2021-09-Tu 04:09:47 
 * @Last Modified by: wulan
 * @decs:支付入参
 */

import { requestCommonParams } from '@/lib/request/requestCommonParams';
const { lang, lat, lng, cityId } = requestCommonParams();
import { getTicket } from '@/utils/user';
import config from '@/config/index';
import { COMMON_INFO } from '@/const/base';
import store from '@/store/index'
import {
  get
} from 'lodash-es'
const country = get(store, 'state.common.country', ''); 

export function payOptions() {
  return {
    appversion: '99.99.99', // 版本号传给ibt固定值
    lang: lang === 'es-419' ? 'es-MX' : lang, // todo钱包内无es-419翻译，先用es-MX兜底
    location_cityid: cityId,
    product_id: 12,
    utc_offset: -480,
    terminal_id: COMMON_INFO.TERMINAL_ID,
    biz_type: 9,
    lat: lat,
    lng: lng,
    source: 'didiFood',
    token: getTicket(),
    location_country:country,
    payHost:config.payApiBase,
    cashierHost:config.cashierApiBase,
  }
}
